import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ConfigurationService} from '../../../../configuration/configuration.service';
import {Subscription} from 'rxjs';
import {ConfigurationModel} from '../../../models/configuration.model';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { LayerTypeFilter } from '../../../../configuration/model/LayerTypeFilter';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import {
  LineStyleEditorComponent
} from '../../line-style-editor/line-style-editor.component';
import { LineStyle } from '../../../models/styling';

export class GpsTracksSettings {
    showRecent: boolean;
    timeLimit: number;
    defaultLegendSettings: LayerTypeFilter;
    styleActive: LineStyle;
    styleRecent: LineStyle;
}

@Component({
  selector: 'app-gps-tracks-config',
  templateUrl: './gps-tracks-config.component.html',
  styleUrl: './gps-tracks-config.component.scss',
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatDialogContent,
    MatFormField,
    MatSelect,
    FormsModule,
    MatOption,
    MatSlideToggle,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    LineStyleEditorComponent,
  ],
})
export class GpsTracksConfigComponent implements OnInit, OnDestroy {
  hours: number[] = [];

  private tenantConfigurationSubscription: Subscription;
  configuration: ConfigurationModel;

  constructor(
    public dialogRef: MatDialogRef<GpsTracksConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GpsTracksSettings,
    private configurationService: ConfigurationService
  ) {
  }

  ngOnInit(): void {
    this.tenantConfigurationSubscription = this.configurationService.sharedConfigurationModel.subscribe(tenantConfiguration => {
      if (tenantConfiguration) {
        this.configuration = tenantConfiguration;
        // array: 1...lookBackPeriod
        this.hours = Array.from({ length: this.configuration.lookBackPeriod }, (x, i) => i + 1);
      }
    });
  }

  ngOnDestroy(): void {
    this.tenantConfigurationSubscription?.unsubscribe();
  }

  reset() {
    this.data.showRecent = true;
    this.data.timeLimit = this.configuration.lookBackPeriod;

    const defaultActive = this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Active');
    if (this.data.styleActive && defaultActive) {
      this.data.styleActive.color = defaultActive.color;
      this.data.styleActive.lineType = defaultActive.dashArray;
    }

    const defaultRecent = this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Recent');
    if (this.data.styleRecent && defaultRecent) {
      this.data.styleRecent.color = defaultRecent.color;
      this.data.styleRecent.lineType = defaultRecent.dashArray;
    }
  }

  isDefault() {
    return (
      this.data.showRecent &&
      this.data.timeLimit === this.configuration.lookBackPeriod &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Active')?.color ===
        this.data.styleActive?.color &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Active')?.dashArray ===
        this.data.styleActive?.lineType &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Recent')?.color ===
        this.data.styleRecent?.color &&
      this.data.defaultLegendSettings.measurementUnits.find(i => i.number === 'Recent')?.dashArray ===
        this.data.styleRecent?.lineType
    );
  }
}
